import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_order_list = createAsyncThunk("orders/get_order_list", async (data) => {
  const body = new FormData();
  body.append("page", data.page);
  body.append("limit", data.rows);
  body.append("type", data.type);
  body.append("action", "list");
  data?.sdate && body.append("from_date", data?.sdate);
  data?.edate && body.append("to_date", data?.edate);

  const response = await fetch(baseUrl + "orders.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log(res);
  return res;
});

export const get_dp_vehicle_list = createAsyncThunk("orders/get_dp_vehicle_list", async (dpId) => {
  console.log("fff",dpId)
  const body = new FormData();
  body.append("action", "dp_vehicle_list");
  body.append("id", dpId);

  const response = await fetch(baseUrl + "orders.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log("Vehicle list response:", res);
  return res;
});

export const get_vehicle_driver_list = createAsyncThunk("orders/get_vehicle_driver_list", async (id) => {
  const body = new FormData();
  body.append("action", "vehicle_driver_list");
  body.append("id", id);

  const response = await fetch(baseUrl + "orders.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log("Driver list response:", res);
  return res;
});

export const get_all_drivers = createAsyncThunk("orders/get_all_drivers", async () => {
  const body = new FormData();
  body.append("action", "get_all_drivers");

  const response = await fetch(baseUrl + "orders.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log("All drivers response:", res);
  return res;
});

const initialState = {
  order_list: [],
  loading: false,
  total_order_count: 0,
  report_url: null,
  dp_vehicle_list: [],
  vehicle_driver_list: [],
  all_drivers: [],
  vehicle_loading: false,
  driver_loading: false,
};

const orderSlice = createSlice({
  name: "orders",
  initialState,

  extraReducers: (builder) => {
    // Order list cases
    builder.addCase(get_order_list.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(get_order_list.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(get_order_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      if (data.success) {
        state.total_order_count = data.totalcount;
        state.order_list = data.reponselist;
        state.report_url = data.report_url;
      } else {
        state.order_list = [];
        state.report_url = null;
      }
    });

    // DP Vehicle list cases
    builder.addCase(get_dp_vehicle_list.pending, (state, action) => {
      state.vehicle_loading = true;
    });
    builder.addCase(get_dp_vehicle_list.rejected, (state, action) => {
      state.vehicle_loading = false;
      state.dp_vehicle_list = [];
    });
    builder.addCase(get_dp_vehicle_list.fulfilled, (state, action) => {
      state.vehicle_loading = false;
      const data = action.payload;
      if (data.success) {
        state.dp_vehicle_list = data.data || [];
      } else {
        state.dp_vehicle_list = [];
      }
    });

    // Vehicle Driver list cases
    builder.addCase(get_vehicle_driver_list.pending, (state, action) => {
      state.driver_loading = true;
    });
    builder.addCase(get_vehicle_driver_list.rejected, (state, action) => {
      state.driver_loading = false;
      state.vehicle_driver_list = [];
    });
    builder.addCase(get_vehicle_driver_list.fulfilled, (state, action) => {
      state.driver_loading = false;
      const data = action.payload;
      if (data.success) {
        // Handle both single driver and array of drivers
        if (data.driver_id && data.driver_name) {
          state.vehicle_driver_list = [{
            id: data.driver_id,
            name: data.driver_name
          }];
        } else if (data.data && Array.isArray(data.data)) {
          state.vehicle_driver_list = data.data;
        } else {
          state.vehicle_driver_list = [];
        }
      } else {
        state.vehicle_driver_list = [];
      }
    });

    // All drivers list cases
    builder.addCase(get_all_drivers.pending, (state, action) => {
      state.driver_loading = true;
    });
    builder.addCase(get_all_drivers.rejected, (state, action) => {
      state.driver_loading = false;
      state.all_drivers = [];
    });
    builder.addCase(get_all_drivers.fulfilled, (state, action) => {
      state.driver_loading = false;
      const data = action.payload;
      if (data.success) {
        if (data.data && Array.isArray(data.data)) {
          state.all_drivers = data.data;
        } else {
          state.all_drivers = [];
        }
      } else {
        state.all_drivers = [];
      }
    });
  },
});

export default orderSlice.reducer;

